import React, {useCallback, useMemo} from "react";
import {useDispatch} from "react-redux";
import {selectedDocumentChanged} from "components/taskdetails-remake/taskDetails.action";
import Tabs from "components/common/Tabs.component";
import {IDropdownListItem} from "types/gaiaComponents/dropdownButton";
import {useTranslation} from "components/translations/useTranslation";

const MAX_TABS = 3;

interface CollapsableTabsProps {
    attachments: Array<{ id: string | number }>;

    setActiveTab: (index: number) => void;
    activeTab: number | null;
}

export const CollapsableTabs = ({
                                    attachments,
                                    activeTab,
                                    setActiveTab
                                }: CollapsableTabsProps): React.ReactElement => {
    const dispatch = useDispatch();
    const { translate } = useTranslation();

    const handleSetActiveTab = useCallback((index: number) => {
        setActiveTab(index);
        dispatch(selectedDocumentChanged(index));
    }, [setActiveTab, dispatch]);

    const tabsArray = useMemo<Array<IDropdownListItem>>(() =>
            attachments.map((attachment, index) => ({
                key: attachment.id.toString(),
                onClick: () => handleSetActiveTab(index),
                text: translate("taskDetail.panels.attachments.attachment") + ` ${index + 1}`,
                dataCy: `__tst_tab_${attachment.id}`,
                selected: activeTab === index
            })),
        [attachments, translate, handleSetActiveTab, activeTab]
    );

    return (
            <Tabs
                items={tabsArray}
                activeTab={activeTab}
                hasMore={attachments.length >= MAX_TABS}
            />
    );
};

export default CollapsableTabs;
